import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeService } from '../employee-profile/employee-profile.service';
import { SharedSkillService } from '../skill-repository/shared-skill.service';
import { SkillRepoEmployeesService } from './skill-repo-employees.service';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { GsdRoles } from 'src/app/enums/gsdRoles.enum';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SkillRepositoryService } from '../skill-repository/skill-repository.service';
import { MatDialog } from '@angular/material/dialog';
import { CompetenciesService } from '../competencies/competencies.service';
import { OthersService } from '../competencies/others/othersDataService';
import { ExcelService } from 'src/app/services/excel-service.service';
import { auto } from '@popperjs/core';

@Component({
  selector: "app-skill-repo-employees",
  templateUrl: "./skill-repo-employees.component.html",
  styleUrls: ["./skill-repo-employees.component.css"],
})
export class SkillRepoEmployeesComponent implements OnInit {

  public CountriesList: any = ["India", "USA", "Mexico", "Taiwan"];
  public CountrySelected: any = [];
  public CertificationStatus: number = -1;
  public empty: string = null;
  public values: any = [];
  public url: any = [];
  public subCompetencies: any = [];
  public from: number;
  public size: number = 6;
  public data: any = [];
  public title: string;
  public subTitle: string;
  isNotUpdatedSince3Months: boolean = false;
  public isSme: number = 0;
  loader: boolean = false;
  showCards: boolean = false;
  showviewMore: boolean = false;
  competencyId: any;
  Resumestatus: number = 0;
  subCompetencyId: any;
  subCompetency: any;
  available: any = -1;
  AvailabilityStatus: number = -1;
  ResignedStatus: number = -1;
  compApiType: any;
  searchText: any;
  noHeader: any;
  role: string;
  adminRole: number = 1;
  isSelectAll = false;
  profileStatus: any;
  countOfSubmittedprofiles: number;
  submittedProfiles: any;
  trueArray: any[];
  submittedEmployeeId: any[] = [];
  emptyArray: any[] = [];
  unCheckedSubscription: Subscription;
  listOfEmployeeIdToApprove: any;
  disbaledbutton: boolean;
  sampleId: number = 2;
  @ViewChild('myInfoDialog') infoDialog = {} as TemplateRef<string>;
  dialogRef: any;
  countOfEmployees: any;
  EmployeesIdsChecked = false;
  CheckedStatusSubscription: Subscription;
  allApprove: any;
  LeadershipRole = false;

  resource: number;
  competency: any;
  compId: any;
  rescount: number
  filtercount: number
  ResourceId: number = 0;
  certications: number = -1;
  certificationId: boolean = false;
  temp: number = -1;
  CMPID: number;
  private pagenavigationSubscription: Subscription;
  sample: any;
  total: any;
  activeEmployeesCount: any;
  inActiveEmployeesCount: any;
  apiLookup: any;
  state: any;
  isApproveAll: boolean = false;
  isFilter: boolean = false;
  filterOpened: boolean = false;
  AppliedFilters: {
    resumestatus: string,
    countrySelected: any[],
    certificationStatus: string,
    availabilityStatus: string,
    resignedStatus: string
  }[] = []
  isSidebarOpen: boolean = false;
  isPanelExpanded = false;
  CountryIsAll: boolean = true;
  isSearchFiltered: boolean = false;
  isAdvancedFilterApplied: boolean = false;
  isExportExcel: boolean = false;

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,

    private employeeService: EmployeeService,
    private service: SkillRepoEmployeesService,
    private sharedSkillService: SharedSkillService,
    private auth: AuthServiceService,
    private toster: ToastrService,
    public skillservice: SkillRepositoryService,
    public dialog: MatDialog,
    private compservice: CompetenciesService,
    private skillRepoEmpservice: SkillRepoEmployeesService,
    private othersService: OthersService,
    private excel: ExcelService


  ) {

    this.unCheckedSubscription = this.sharedSkillService.getUnselected().subscribe(x => { this.isSelectAll = x });
    this.CheckedStatusSubscription = this.sharedSkillService.getCheckedEmployeeStatus().subscribe(x => { this.EmployeesIdsChecked = x })


  }
  ngOnDestroy() {

    this.unCheckedSubscription.unsubscribe();
    this.pagenavigationSubscription.unsubscribe();
    this.CheckedStatusSubscription.unsubscribe();
    sessionStorage.removeItem("SubcompId");
  }
  ngOnInit() {
    const textSearched = this.sharedSkillService.getSearchText();
    if (textSearched != "") {
      this.isSearchFiltered = true;
    }
    this.activeRoute.queryParams.subscribe((params) => {
      if ('AppliedFilters' in params) {
        this.AppliedFilters = JSON.parse(params.AppliedFilters);
        this.CountrySelected = this.AppliedFilters[0].countrySelected;
        this.Resumestatus = Number(this.AppliedFilters[0].resumestatus);
        this.CertificationStatus = Number(this.AppliedFilters[0].certificationStatus);
        this.AvailabilityStatus = Number(this.AppliedFilters[0].availabilityStatus);
        this.ResignedStatus = Number(this.AppliedFilters[0].resignedStatus);
      }
      else {
        this.Resumestatus = 0;
        this.CountrySelected = null;
        this.CertificationStatus = -1;
        this.AvailabilityStatus = -1;
        this.ResignedStatus = -1;
      }
    });

    this.pagenavigationSubscription = this.sharedSkillService.pagenavigationId$.subscribe(value => {
      this.CMPID = value.resource;
      if (this.CMPID == 0 || this.CMPID == undefined) {
        this.CMPID = Number(sessionStorage.getItem("resource"))
      }
      this.competencyId = value.competencyId
      if (this.competencyId == null) {
        this.competencyId = Number(sessionStorage.getItem("compId"))
      }
      this.subCompetencyId = value.subCompId
      if ((this.subCompetencyId == null || this.subCompetencyId == 0) && sessionStorage.getItem("navigating") === "true") {
        this.subCompetencyId = Number(sessionStorage.getItem("SubcompId"))
      }

      if (this.CMPID == 1 || this.CMPID == 2) {

        this.state = value.options

        if (this.state == 0 || this.state == undefined) {
          this.state = Number(sessionStorage.getItem("filter"))
        }
        this.available = this.state;
      }
      this.getLookup();
    })
    if (this.CMPID == 1 || this.CMPID == 2) {
      this.othersService.id$.subscribe(values => {
        this.subCompetencyId = values
      })
    }
    if (this.CMPID == 3) {

      this.skillservice.sharedVariable$.subscribe(value => {
        this.competencyId = value.message;
        this.title = value.compTitle;

      })
      if (this.title == null || this.title == undefined) {
        this.title = sessionStorage.getItem("compTitle");
      }

      if (this.competencyId == null) {
        this.competencyId = sessionStorage.getItem("compId")
      }

    }

    this.role = this.auth.getRole();
    if (this.role.includes(GsdRoles.SuperAdmin)) {
      this.adminRole = 0;
    }
    if (this.role.includes(GsdRoles.Leadership)) {
      this.LeadershipRole = true;
    }
    this.from = 0;
    this.subTitle = localStorage.getItem("compSubTitle");
    this.activeRoute.params.subscribe((params) => {
      this.loader = true;

      this.ResourceId = params["resource"];
      this.sharedSkillService.setCompId(this.competencyId);
      if (this.CMPID == 1) { this.compApiType = "all" }
      else if (this.CMPID == 2) {
        if (this.state == 1) { this.compApiType = "pendingCertifications" }
        else if (this.state == 2) { this.compApiType = "certified" }
      }
      else if (this.CMPID == 3) {
        this.compApiType = "skillrepo"
      }


      this.searchText = this.sharedSkillService.getSearchText();
      this.profileStatus = params["name"];
      if (this.CMPID == 3) {
        if (this.profileStatus == undefined || this.profileStatus == 'All') {
          this.available = "-1";
        }
        else {
          switch (this.profileStatus) {
            case "Submitted":
              this.available = "1";
              break;
            case "Not Submitted":
              this.available = "2";
              break;
            case "Approved":
              this.available = "3";
              break;
            case "Rejected":
              this.available = "4";
              break;
          }
        }
      }
      this.sharedSkillService.setAvailability(this.available);

      this.subCompetencyId = this.sharedSkillService.getsubCompId() == ""
        ? 0 : this.sharedSkillService.getsubCompId();
      if ((this.subCompetencyId == null || this.subCompetencyId == 0) && sessionStorage.getItem("navigating") === "true") {
        this.subCompetencyId = Number(sessionStorage.getItem("SubcompId"))
      }
      this.subCompetency = this.sharedSkillService.getsubComp();
      this.sharedSkillService.setSelected(this.emptyArray, this.isSelectAll);
      this.service
        .getSubCompetenciesForDropDowns(this.competencyId)
        .subscribe((res) => {
          this.subCompetencies = res.data;
        });
      if (this.CMPID == 1 || this.CMPID == 2) {
        this.othersService.name$.subscribe(values => {
          this.subCompetency = values
          if (this.subCompetency == null || this.subCompetency == "") {
            this.subCompetency = sessionStorage.getItem("SubcompTitle")
          }

        })
      }
      this.loadEmployees(false);
    });
    this.filtercount = this.rescount
    this.certificationId = this.service.certificateId;
    this.ResourceId = this.service.resorceId;
    this.isSelectAll = false;
    sessionStorage.setItem("navigating", "false");
    this.isNotUpdatedSince3Months = false;
    this.isSme = 0;
    const titled = this.title.replace(' ', '%20')
    if (this.router.url === `/Home/Skill%20Repository/${titled}`) {
      this.subCompetencyId = 0;
    }
  }
  getLookup() {
    this.apiLookup = {
      sme: "getAllSMEs",
      certified: "getAllCertifiedResources",
      available: "getAllAvailableResources",
      pendingCertifications: "getAllCertificationInProgressResources",
      competency: "getAvailableProfilesbyCompetencyId",
      search: "getEmployees",
      allocatedResources: "getAllAvailableResources",
      skillrepo: "getEmployeesByCompId",
      all: "getFilteredResources"
    };
  }
  navigateBack() {
    this.router.navigate(["Home/Skill Repository"]);
  }
  naviagteToEmployeeDetails() {
    this.sharedSkillService.setEmployeeId(null);
    this.router.navigate([`Home/skill_repo/${this.title}/Employee Details`]);
  }
  changefiltervalue(): boolean {

    if (this.available == 1 && Number(sessionStorage.getItem("filter")) === 1 && !this.LeadershipRole) {
      return true
    }
    else {
      return false
    }
  }
  filterChange(value) {
    sessionStorage.setItem("filter", value)
    this.changefiltervalue();

    this.pagenavigationSubscription = this.sharedSkillService.pagenavigationId$.subscribe(value => {
      this.subCompetencyId = value.subCompId
      if (this.subCompetencyId == null || this.subCompetencyId == 0) {
        this.subCompetencyId = Number(sessionStorage.getItem("SubcompId"))
      }
    })
    let resourcefilter: any
    let competencyname: any
    const status = value;

    if (this.CMPID == 2) {
      this.state = status
      if (this.state == 1) { this.compApiType = "pendingCertifications" }
      else if (this.state == 2) { this.compApiType = "certified" }
    }
    let passSubCompetency: string;
    if (this.CMPID == 3) {
      if (value == -1) {
        passSubCompetency = 'All'
      } else if (status == 2) {
        passSubCompetency = "Not Submitted"
      } else if (status == 1) {
        passSubCompetency = "Submitted"
      } else if (status == 3) {
        passSubCompetency = 'Approved'
      } else if (status == 4) {
        passSubCompetency = 'Rejected'
      }
    }
    this.sharedSkillService.setAvailability(value);
    this.isSelectAll = false;
    this.sharedSkillService.setSelected(this.emptyArray, this.isSelectAll);
    this.available = value;
    this.from = 0;
    this.size = 6;
    if (this.CMPID == 3) {
      this.router.resetConfig(this.router.config); /*this line will clear*/
      this.router.navigate([`Home/Skill Repository/${this.title}/${passSubCompetency}`], {
        queryParams: { AppliedFilters: JSON.stringify(this.AppliedFilters) },
      });
      sessionStorage.setItem("navigating", "true");
    }
    let tempCompetencyName: string;
    let tempSubCompId: number;
    let tempSubCompName: string;
    this.pagenavigationSubscription = this.sharedSkillService.pagenavigationId$.subscribe(value => {
      tempCompetencyName = value.competencyName
      if (tempCompetencyName == null || tempCompetencyName == "") {
        tempCompetencyName = sessionStorage.getItem("compTitle")
      }
    })
    this.othersService.id$.subscribe(id => {
      tempSubCompId = id;
      if (tempSubCompId == null || tempSubCompId == 0) {
        tempSubCompId = Number(sessionStorage.getItem("SubcompId"))
      }

    });
    this.othersService.name$.subscribe(name => {
      tempSubCompName = name;
      if (tempSubCompName == null || tempSubCompName == "") {
        tempSubCompName = sessionStorage.getItem("SubcompTitle")
      }
    });

    this.sharedSkillService.setpagenavigationId({
      resource: this.CMPID,
      competencyId: this.competencyId,
      options: value,
      competencyName: tempCompetencyName,
      subCompId: tempSubCompId
    });
    if (this.CMPID == 1) {
      this.skillRepoEmpservice.resourceroute(tempCompetencyName, tempSubCompId, tempSubCompName, value)
      this.pagenavigationSubscription = this.sharedSkillService.pagenavigationId$.subscribe(value => {
        this.subCompetencyId = value.subCompId
      })
    }

    if (this.CMPID == 2) {
      this.skillRepoEmpservice.certificateroute(tempCompetencyName, tempSubCompId, tempSubCompName, value)
      this.pagenavigationSubscription = this.sharedSkillService.pagenavigationId$.subscribe(value => {
        this.subCompetencyId = value.subCompId
      })
    }


  }
  Resumefilter(value) {
    sessionStorage.setItem("resume", value)
    this.sharedSkillService.setresumestate(value);
    this.from = 0;
    this.size = 6;
    this.loadEmployees(false);[]
  }

  subCompetencyChange(value) {
    let competencyname: any
    let passSubCompetency: string;
    this.compservice.competencyName$.subscribe(x => {
      competencyname = x
      if (competencyname == null || competencyname == "") {
        competencyname = sessionStorage.getItem("compTitle")
      }
    })

    let filter: any

    this.pagenavigationSubscription = this.sharedSkillService.pagenavigationId$.subscribe(value => {
      filter = value.options;
      if (filter == null) {
        filter = sessionStorage.getItem("filter")
      }

    })
    this.subCompetencyId = value;
    this.sharedSkillService.setSubCompId(this.subCompetencyId);
    if (this.subCompetencyId != "0") {
      this.subCompetency = this.subCompetencies.find(
        ({ id }) => id == Number(value)
      ).name;
    } else {
      this.subCompetency = null;
    }
    this.sharedSkillService.setSubComp(this.subCompetency);
    this.othersService.updateId(this.subCompetencyId);
    this.othersService.updateName(this.subCompetency)
    sessionStorage.setItem("SubcompId", this.subCompetencyId)
    sessionStorage.setItem("SubcompTitle", this.subCompetency)

    this.from = 0;
    this.size = 6;
    if (this.CMPID == 1) {
      this.skillRepoEmpservice.resourceroute(competencyname, this.subCompetencyId, this.subCompetency, filter)
      this.pagenavigationSubscription = this.sharedSkillService.pagenavigationId$.subscribe(value => {
        this.subCompetencyId = value.subCompId
      })
    }

    if (this.CMPID == 2) {

      this.skillRepoEmpservice.certificateroute(competencyname, this.subCompetencyId, this.subCompetency, filter)
      this.pagenavigationSubscription = this.sharedSkillService.pagenavigationId$.subscribe(value => {
        this.subCompetencyId = value.subCompId
      })
    }

    this.loadEmployees(false);
  }

  searchButton() {
    this.isSearchFiltered = true;
    this.sharedSkillService.setSearchText(this.searchText);
    this.from = 0;
    this.size = 6;
    this.loadEmployees(false);
  }
  clearSearchText() {
    this.isSearchFiltered = false;
    this.searchText = "";
    this.sharedSkillService.setSearchText(this.searchText);
    this.loadEmployees(false);
  }

  loadEmployees(viewmore) {
    if (
      this.employeeService &&
      this.employeeService[this.apiLookup[this.compApiType]]
    ) {
      const searchTextLower = this.searchText ? this.searchText.toLowerCase().replace(/\s/g, '') : '';
      if (searchTextLower.includes("talentpool") || searchTextLower.toLowerCase() === "talent" || searchTextLower.toLowerCase() === "pool") {
        this.data = [];
        this.showCards = true;
        this.showviewMore = false;
        return;
      }
      this.loader = true;
      this.employeeService[this.apiLookup[this.compApiType]](
        this.from,
        this.size,
        this.competencyId,
        this.Resumestatus,
        this.available,
        this.subCompetencyId,
        this.subCompetency,
        this.searchText,
        this.CountrySelected,
        this.CertificationStatus,
        this.AvailabilityStatus,
        this.ResignedStatus,
        this.isNotUpdatedSince3Months,
        this.isSme,
         this.isExportExcel
      ).subscribe(
        (x) => {
          this.total = x.data.total;
          this.activeEmployeesCount = x.data.activeEmployeesCount;
          this.inActiveEmployeesCount = x.data.inActiveEmployeesCount;
          if (viewmore) {
            if (this.CMPID == 3) { this.data = this.data.concat(x.data.items); }
            else {
              this.data = this.data.concat(x.data.profiles);
            }
            this.getSubmittedProfilesCount(this.data);
          }
          else {
            if (this.CMPID == 3) {
              this.data = x.data.items;
            }
            else { this.data = x.data.profiles; }

            this.getSubmittedProfilesCount(this.data);
          }
          if (this.data.length <= x.data.total) this.showviewMore = false;
          this.showCards = true;

          if (x.data.total > this.from + this.size) this.showviewMore = true;
          this.loader = false;

        },
        (error) => {
          this.loader = false;
        }
      );
    }
  }

  viewMore() {
    this.from += this.size;
    this.loader = true;
    this.showviewMore = false;
    this.loadEmployees(true);
  }
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    $("#sidebar_r").removeClass("active");
    $("#sidebar").removeClass("active");
    $(".overlay").removeClass("active");
  }
  selectAll(event: any) {
    if (event.target.checked) {
      this.isSelectAll = true;
      this.sharedSkillService.setSelected(this.submittedEmployeeId, this.isSelectAll);
    }
    else {
      this.isSelectAll = false;
      this.sharedSkillService.setSelected(this.emptyArray, this.isSelectAll)
    }
  }
  NotUpdatedSince3Months(event: any) {
    // if (event.target.checked) {
    //   this.isNotUpdatedSince3Months = true;
    // }
    // else {
    //   this.isNotUpdatedSince3Months = false;
    // }
    this.isNotUpdatedSince3Months = event.target.checked ? true : false;

  }

  SME(event: any) {
    // if (event.target.checked) {
    //   this.isSme = 3;
    // }
    // else {
    //   this.isSme = 0;
    // }
    this.isSme = event.target.checked ? 3 : 0;

  }

  getSubmittedProfilesCount(value: []) {
    const filterColumn = 'employeeProfileStatus'
    this.submittedProfiles = value.filter(i => i[filterColumn] == 1);
    this.submittedProfiles.forEach(i => this.getsubmittedEmployeeId(i));

  }
  getsubmittedEmployeeId(item) {
    this.submittedEmployeeId.push(item.employeeId);
    this.sharedSkillService.getAllSubmittedEmployeeIds(this.submittedEmployeeId);
  }
  setCheckedEmployeesNull() {
    this.sharedSkillService.setSelected(this.emptyArray, false);
    if (this.isSelectAll) {
      this.isSelectAll = false;
    }

  }
  ApproveAll() {
    this.allApprove = this.sharedSkillService.getAllApprove();
    if (this.allApprove) {
      this.listOfEmployeeIdToApprove = this.sharedSkillService.getUnCheckedEmployeeIds();
    }
    else {
      this.listOfEmployeeIdToApprove = this.listOfEmployeeIdToApprove.filter((item, index) => this.listOfEmployeeIdToApprove.indexOf(item) === index);
    }

    this.employeeService.managerApprovalbycompetenyId(this.allApprove, parseInt(this.competencyId), this.listOfEmployeeIdToApprove).subscribe(x => {
      if (this.listOfEmployeeIdToApprove.length == 1) {
        this.toster.success("Selected Employee is Approved");
      }
      else {
        this.toster.success("Approved All Employees Selected");

      }


      this.from = 0;
      this.size = 6;
      this.available = -1;
      this.setCheckedEmployeesNull();
      this.router.navigate([`Home/Skill Repository/${this.title}`]);
    },
      error => {
        this.toster.error('Invalid')
        this.from = 0;
        this.size = 6;
        this.available = 1;
        this.setCheckedEmployeesNull();
        this.router.navigate([`Home/Skill Repository/${this.title}`]);
      }
    );


  }
  getSubCompNameorId() {

    if (this.CMPID == 1 || this.CMPID == 2) {
      return this.subCompetency
    }
    else if (this.CMPID == 3) {
      return this.subCompetencyId
    }
  }

  openInfoDialog() {
    let myInfo: any

    this.listOfEmployeeIdToApprove = this.sharedSkillService.getCheckedEmployeeIds();
    let countOfEmployees = this.listOfEmployeeIdToApprove.length.toString();

    if (this.isSelectAll) {
      myInfo = " Are you sure, want to approve all the employees under you?"
    }
    else {
      myInfo = "Are you sure, want to approve " + countOfEmployees + " Employee(s)?"
    }

    this.dialogRef = this.dialog.open(this.infoDialog,
      {
        data: myInfo, height: auto, width: auto,
        minWidth: '550px'
      });


    this.dialogRef.afterClosed().subscribe(() => {
    });
  }
  closeFilter() {
    this.isSidebarOpen = false;
  }
  closeFilterOnScreen() {
  }
  filterEnable() {
    this.filterOpened = !this.filterOpened;
    this.isFilter = !this.isFilter;
  }
  enableApproveButton() {
    if (this.isSelectAll || this.EmployeesIdsChecked) {
      return false
    }
    else {
      return true;
    }
  }

  empdata: any
  totalsize: any

  toPascalCase(str) {
    return str.replace(/(\w)(\w*)/g, function (g0, g1, g2) {
      return g1.toUpperCase() + g2;
    });
  }

  exportExcel() {
    if (this.AvailabilityStatus == 0 && this.ResignedStatus == 1) {
      return this.toster.error("There Won't be any employee Who is Resigned and Billable")
    }
    this.from = 0;
    this.isExportExcel = true;
    this.employeeService.getEmployeesByCompId(this.from, this.size, this.competencyId, this.Resumestatus, this.available, this.subCompetencyId, this.subCompetency, this.searchText, this.CountrySelected, this.CertificationStatus, this.AvailabilityStatus, this.ResignedStatus, this.isNotUpdatedSince3Months, this.isSme, true).subscribe(
      x => {
        this.empdata = x.data;
        this.totalsize = x.data.total;
        setTimeout(() => {
          this.employeeService.getEmployeesByCompId(this.from, this.totalsize, this.competencyId, this.Resumestatus, this.available, this.subCompetencyId, this.subCompetency, this.searchText, this.CountrySelected, this.CertificationStatus, this.AvailabilityStatus, this.ResignedStatus, this.isNotUpdatedSince3Months, this.isSme, true).subscribe(x => {
            const selectedFields = ['employeeId', 'firstName', 'lastName', 'emailAddress', 'grade', 'projectName', 'managerName', 'competencyName', 'subCompetencyNames', 'country', 'location', 'status', 'skills', 'resumeDownloadUrl'];
            const excelData = x.data.items.map(item => {
              const selectedItem = {};
              selectedFields.forEach(field => {
                if (field === 'subCompetencyNames') {
                  const subCompetencyNames = item[field].join(', ');
                  selectedItem[this.toPascalCase(field)] = subCompetencyNames;
                }
                else if (field === 'competencyName') {
                  const competencyName = item[field].join(', ');
                  selectedItem[this.toPascalCase(field)] = competencyName;
                }
                else if (field === 'status') {
                  selectedItem[this.toPascalCase(field)] = item.isDeleted ? 'Resigned' : 'Available';
                }
                else if (field === 'managerName') {
                  selectedItem[this.toPascalCase(field)] = item.managerFirstName + ' ' + item.managerLastName;
                }
                else if (field === 'skills') {
                  selectedItem[this.toPascalCase(field)] = item.primarySkills?.map(s => s.skill)?.join(', ');
                }
                else if(field === 'resumeDownloadUrl'){
                  const resumeUrl = item[field];
                  if (resumeUrl && resumeUrl.trim() !== "") {
                    selectedItem["Resume"] = `=HYPERLINK("${resumeUrl}", "Resume Link")`;
                  } else {
                    selectedItem["Resume"] = "Not available";
                  }
                }
                else {
                  selectedItem[this.toPascalCase(field)] = item[field];
                }
              });
              return selectedItem;
            });
            this.excel.exportAsExcelFile(excelData, this.profileStatus);
          })
        })
      })
    this.isExportExcel = false;
  }
  ChangeCountry() {
    this.employeeService.getEmployeesByCompId(this.from, this.size, this.competencyId, this.Resumestatus, this.available, this.subCompetencyId, this.subCompetency, this.searchText, this.CountrySelected, this.CertificationStatus, this.AvailabilityStatus, this.ResignedStatus, this.isNotUpdatedSince3Months, this.isSme, this.isExportExcel).subscribe(
      x => this.data = x.data.items

    );
  }

  ChangeCertStatus() {
    this.employeeService.getEmployeesByCompId(this.from, this.size, this.competencyId, this.Resumestatus, this.available, this.subCompetencyId, this.subCompetency, this.searchText, this.CountrySelected, this.CertificationStatus, this.AvailabilityStatus, this.ResignedStatus, this.isNotUpdatedSince3Months, this.isSme, this.isExportExcel).subscribe(
      y => this.data = y.data.items
    );
  }
  ApplyFilter() {
    this.AppliedFilters = [];
    this.AppliedFilters.push({
      resumestatus: this.Resumestatus.toString(),
      countrySelected: this.CountrySelected,
      certificationStatus: this.CertificationStatus.toString(),
      availabilityStatus: this.AvailabilityStatus.toString(),
      resignedStatus: this.ResignedStatus.toString()
    });

    if (this.Resumestatus || this.CountrySelected || this.CertificationStatus != -1 || this.AvailabilityStatus != -1 || this.ResignedStatus != -1 || this.isNotUpdatedSince3Months || this.isSme) {
      this.isAdvancedFilterApplied = true;
    }
    else {
      this.isAdvancedFilterApplied = false;
    }
    this.isFilter = false;
    this.filterOpened = false;
    if (this.AvailabilityStatus == 0 && this.ResignedStatus == 1) {
      return this.toster.error("There Won't be any employee Who is Resigned and Billable")
    }
    this.from = 0;
    this.employeeService.getEmployeesByCompId(
      this.from, 
      this.size, 
      this.competencyId, 
      this.Resumestatus, 
      this.available, 
      this.subCompetencyId, 
      this.subCompetency, 
      this.searchText, 
      this.CountrySelected, 
      this.CertificationStatus, 
      this.AvailabilityStatus, 
      this.ResignedStatus, 
      this.isNotUpdatedSince3Months, 
      this.isSme,
      this.isExportExcel
    ).subscribe(
      (response: any) => {
        this.total = response.data.total;
        this.data = response.data.items;
  
        // Update active and inactive employee counts
        this.activeEmployeesCount = response.data.activeEmployeesCount;
        this.inActiveEmployeesCount = response.data.inActiveEmployeesCount;
  
        // Check if the "view more" button should be displayed
        this.showviewMore = response.data.total > this.from + this.size;
      },
      (error) => {
        // Handle error case if needed
        console.error('Error fetching employee data', error);
      }
    );
  }


  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }
  getCheckedResume(number) {
    if (this.Resumestatus == number) {
      return true;
    }
    else {
      return false
    }
  }
  updatedResume(event) {
    this.Resumestatus = event.target.value;

  }
  getCheckedCountry(country) {
    if ((this.CountrySelected == null || this.CountrySelected.length == 0) && this.CountryIsAll && country == '') {
      return true;
    }
    else if (country !== '' && this.CountrySelected !== null) {
      // return this.CountrySelected.indexOf(country) >= 0;
      const bool = this.CountrySelected.some(e => e == country);
      if (bool) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false
    }
  }
  updatedCountry(event, country) {
    if (event.target.checked) {
      if (country == '') {
        this.CountrySelected = null;
        this.CountryIsAll = true;

      }
      else {
        if (this.CountrySelected == null) {
          this.CountrySelected = [];
          this.CountrySelected.push(country);
        }
        else {
          this.CountrySelected.push(country);
        }
        this.CountryIsAll = false;
      }
    }
    else {
      this.CountrySelected = this.CountrySelected.filter(e => { return e !== country });
    }
  }
  getCheckedCertifications(number) {
    if (this.CertificationStatus == number) {
      return true;
    }
    else {
      return false
    }
  }
  updatedCertification(event) {
    this.CertificationStatus = event.target.value;
  }
  getCheckedAvailability(number) {
    if (this.AvailabilityStatus == number) {
      return true;
    }
    else {
      return false
    }
  }
  updatedAvailability(event) {
    this.AvailabilityStatus = event.target.value;
  }
  getCheckedResigned(number) {
    if (this.ResignedStatus == number) {
      return true;
    }
    else {
      return false
    }
  }
  updatedResigned(event) {
    this.ResignedStatus = event.target.value;
  }
  ClearFilter() {
    this.Resumestatus = 0;
    this.CountrySelected = null;
    this.CountryIsAll = true;
    this.CertificationStatus = -1;
    this.AvailabilityStatus = -1;
    this.ResignedStatus = -1;
    this.isNotUpdatedSince3Months = false;
    this.isSme = 0;
    this.isAdvancedFilterApplied = false;
  }
}

